<template>
    <div class="content">
        <ContentComponentItem
            v-for="(component, key) in data.content"
            :key="key"
            :data="component"
            :background="background"
            :has-eager-image="hasEagerImage"
        />
    </div>
</template>

<script setup lang="ts">
import type { Color, ComponentContentFragment } from '@/graphql/api'

import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'

defineProps<{
    data: ComponentContentFragment
    background: Color
    hasEagerImage?: boolean
}>()
</script>

<style lang="scss" scoped>
.content {
    padding: 0 20px;
}
</style>
